"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * DataTableView ist die tabellarische Ansicht für die Entity
 *
 */
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var configurationTypes_1 = require("../../shared/types/configurationTypes");
var getFetchHeaders_1 = __importDefault(require("../../shared/util/getFetchHeaders"));
var commonTypes_1 = require("../../shared/types/commonTypes");
var loadListEntityData_1 = __importDefault(require("../../fetch/loadListEntityData"));
var crude_selector_1 = require("../../store/crude/crude.selector");
var DataTable_1 = __importDefault(require("../../screens/DataTableView/DataTable"));
var JoinEntity_1 = __importDefault(require("../../screens/DataTableView/JoinEntity"));
var DataEditView_1 = __importDefault(require("../../screens/DataEditView/DataEditView"));
var crudeActions = __importStar(require("../../store/crude/crude.actions"));
var crude_actions_1 = require("../../store/crude/crude.actions");
var translateMessage_1 = __importDefault(require("../../shared/util/translateMessage"));
var messageTypes_1 = require("../../shared/types/messageTypes");
var getDefaultTableFilterSettings_1 = __importDefault(require("../../defaults/getDefaultTableFilterSettings"));
var DataResponsiveTable_1 = __importDefault(require("../DataResponsiveView/DataResponsiveTable"));
var ResponsiveJoinEntity_1 = __importDefault(require("../DataResponsiveView/ResponsiveJoinEntity"));
var DataTableView = function (props) {
    var _a;
    var dispatch = react_redux_1.useDispatch();
    var activeEntity = react_redux_1.useSelector(crude_selector_1.getActiveEntity);
    var screenDesign = react_redux_1.useSelector(crude_selector_1.getScreenDesign);
    var reloadListEntity = react_redux_1.useSelector(crude_selector_1.getReloadListEntity);
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var fetchHeaders = crudeConfig.api.headers ? getFetchHeaders_1.default(crudeConfig.api.headers) : {};
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var storedTableFilterSettings = react_redux_1.useSelector(crude_selector_1.getTableFilterSettings);
    var dataViewType = props.dataViewType || commonTypes_1.DataViewType.fullView;
    var entity = props.entity;
    var entityTab = (_a = crudeConfig.tabs) === null || _a === void 0 ? void 0 : _a.find(function (tab) { return tab.entity === entity; });
    var techFilter = (entityTab && entityTab.filter) || undefined;
    var embeddingEntityFilter = props.embeddingEntityFilter || undefined;
    var _b = react_1.useState(storedTableFilterSettings[entity][props.treeViewLevel]), tableFilterSettings = _b[0], setTableFilterSettings = _b[1];
    var _c = react_1.useState(storedTableFilterSettings[entity][props.treeViewLevel]), entityFilterSettings = _c[0], setEntityFilterSettings = _c[1];
    var _d = react_1.useState(storedTableFilterSettings[entity][props.treeViewLevel]), joinFilterSettings = _d[0], setJoinFilterSettings = _d[1];
    var _e = react_1.useState(), data = _e[0], setData = _e[1];
    var _f = react_1.useState(), joinEntityData = _f[0], setJoinEntityData = _f[1];
    var _g = react_1.useState(), editView = _g[0], setEditView = _g[1];
    var _h = react_1.useState(), message = _h[0], setMessage = _h[1];
    react_1.useEffect(function () {
        var _a, _b;
        if (!storedTableFilterSettings[entity][props.treeViewLevel]) {
            var newFilterSettings = __assign(__assign({}, storedTableFilterSettings), (_a = {}, _a[entity] = __assign(__assign({}, storedTableFilterSettings[entity]), (_b = {}, _b[props.treeViewLevel] = getDefaultTableFilterSettings_1.default(), _b)), _a));
            dispatch(crudeActions.setTableFilterSettings(newFilterSettings));
        }
    }, []);
    react_1.useEffect(function () {
        if (message && crudeLabels) {
            var text = translateMessage_1.default(message.message, crudeLabels, props.entity);
            var newMessage = {
                eventType: message.eventType,
                severity: message.status && message.status >= 400 ? messageTypes_1.Severity.error : messageTypes_1.Severity.success,
                message: text,
            };
            message && dispatch(crudeActions.addMessage(newMessage));
        }
    }, [message]);
    react_1.useEffect(function () {
        if (reloadListEntity === entity) {
            switchDataLoading();
        }
    }, [reloadListEntity]);
    var loadJoinData = function () {
        var filter = __assign({}, joinFilterSettings);
        if ((embeddingEntityFilter === null || embeddingEntityFilter === void 0 ? void 0 : embeddingEntityFilter.value) === 'new' || screenDesign === commonTypes_1.ScreenDesign.mobile) {
            filter.pageSize = 999999;
        }
        if ((embeddingEntityFilter === null || embeddingEntityFilter === void 0 ? void 0 : embeddingEntityFilter.value) !== 'new') {
            loadListEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, entity, fetchHeaders, filter, embeddingEntityFilter, techFilter, setJoinEntityData, setMessage, ['include_self_previews', 'join_invert']);
        }
        else {
            loadListEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, entity, fetchHeaders, filter, undefined, techFilter, setJoinEntityData, setMessage, ['include_self_previews', 'join_invert']);
        }
    };
    var loadEntityData = function () {
        var filter = __assign({}, joinFilterSettings);
        if (screenDesign !== commonTypes_1.ScreenDesign.mobile) {
            filter.pageSize = 999999;
        }
        if ((embeddingEntityFilter === null || embeddingEntityFilter === void 0 ? void 0 : embeddingEntityFilter.value) !== 'new') {
            loadListEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, entity, fetchHeaders, entityFilterSettings, embeddingEntityFilter, techFilter, setData, setMessage, ['include_self_previews']);
        }
        else {
            setData({
                data: [],
                instancePermissions: {},
                entityReferencePreviews: {},
                thumbnailData: {},
                hasChildren: {},
                joinContext: {},
                totalPages: 0,
                totalElements: 0,
            });
        }
    };
    var loadTableData = function () {
        loadListEntityData_1.default(crudeConfig.api.restPath, crudeConfig.api.app, entity, fetchHeaders, tableFilterSettings, embeddingEntityFilter, techFilter, setData, setMessage, ['include_self_previews']);
    };
    var switchDataLoading = function () {
        dispatch(crude_actions_1.setReloadListEntity(undefined));
        if (embeddingEntityFilter && embeddingEntityFilter.joinEntity && props.dataViewType !== commonTypes_1.DataViewType.simpleView) {
            // hier wird die Page wieder auf 0 gesetzt, weil es sein kann, dass die aktuelle page weggefallen ist. Filter bleiben bestehen
            setEntityFilterSettings(__assign(__assign({}, entityFilterSettings), { page: 0 }));
            setJoinFilterSettings(__assign(__assign({}, joinFilterSettings), { page: 0 }));
        }
        else {
            loadTableData();
        }
    };
    react_1.useEffect(function () {
        if (embeddingEntityFilter && embeddingEntityFilter.joinEntity && props.dataViewType !== commonTypes_1.DataViewType.simpleView) {
            loadEntityData();
        }
    }, [entityFilterSettings]);
    react_1.useEffect(function () {
        if (embeddingEntityFilter && embeddingEntityFilter.joinEntity && props.dataViewType !== commonTypes_1.DataViewType.simpleView) {
            loadJoinData();
        }
    }, [joinFilterSettings]);
    react_1.useEffect(function () {
        switchDataLoading();
    }, [tableFilterSettings, activeEntity, entity, props.dataViewType]);
    react_1.useEffect(function () {
        // wenn sich die storedTableFilterSettings ändern, müssen wir die Daten nachladen, aber nur bei Änderungen
        if (storedTableFilterSettings && JSON.stringify(storedTableFilterSettings[entity][props.treeViewLevel]) !== JSON.stringify(tableFilterSettings)) {
            setTableFilterSettings(storedTableFilterSettings[entity][props.treeViewLevel]);
        }
        if (storedTableFilterSettings && JSON.stringify(storedTableFilterSettings[entity][props.treeViewLevel]) !== JSON.stringify(entityFilterSettings)) {
            setEntityFilterSettings(storedTableFilterSettings[entity][props.treeViewLevel]);
        }
        if (storedTableFilterSettings && JSON.stringify(storedTableFilterSettings[entity][props.treeViewLevel]) !== JSON.stringify(joinFilterSettings)) {
            setJoinFilterSettings(storedTableFilterSettings[entity][props.treeViewLevel]);
        }
    }, [storedTableFilterSettings]);
    react_1.useEffect(function () {
        if (reloadListEntity === entity) {
            switchDataLoading();
        }
    }, [reloadListEntity]);
    return (react_1.default.createElement(react_1.default.Fragment, null, data &&
        react_1.default.createElement(react_1.default.Fragment, null,
            editView &&
                react_1.default.createElement(DataEditView_1.default, { entity: editView.entity, id: editView.id, treeViewLevel: editView.treeViewLevel + 1 }),
            !editView &&
                react_1.default.createElement(react_1.default.Fragment, null, (dataViewType === commonTypes_1.DataViewType.fullView) && (embeddingEntityFilter && embeddingEntityFilter.joinEntity) && joinEntityData
                    ? (react_1.default.createElement(react_1.default.Fragment, null, entity && screenDesign === commonTypes_1.ScreenDesign.mobile
                        ? (react_1.default.createElement(react_1.default.Fragment, null, (props.layout === configurationTypes_1.JoinEntityLayout.multiSelectDropdown || props.layout === configurationTypes_1.JoinEntityLayout.multiSelectAutoComplete)
                            ? (react_1.default.createElement(JoinEntity_1.default, { layout: props.layout, min: props.min, max: props.max, embeddingEntityFilter: embeddingEntityFilter, joinEntity: embeddingEntityFilter.joinEntity, tableFilterSettings: tableFilterSettings, entity: entity, treeViewLevel: props.treeViewLevel, dataViewType: commonTypes_1.DataViewType.simpleView, joinEntityData: joinEntityData, entityData: data, mainEntityId: embeddingEntityFilter.value, changeEntityFilterSettings: function (settings) { return setEntityFilterSettings(settings); }, changeJoinFilterSettings: function (settings) { return setJoinFilterSettings(settings); }, reloadJoinEntityData: function () {
                                    switchDataLoading();
                                } }))
                            : (react_1.default.createElement(ResponsiveJoinEntity_1.default, { embeddingEntityFilter: embeddingEntityFilter, joinEntity: embeddingEntityFilter.joinEntity, tableFilterSettings: tableFilterSettings, entity: entity, treeViewLevel: props.treeViewLevel, dataViewType: commonTypes_1.DataViewType.simpleView, joinEntityData: joinEntityData, entityData: data, mainEntityId: embeddingEntityFilter.value, changeEntityFilterSettings: function (settings) { return setEntityFilterSettings(settings); }, changeJoinFilterSettings: function (settings) { return setJoinFilterSettings(settings); }, reloadJoinEntityData: function () {
                                    switchDataLoading();
                                } }))))
                        : (react_1.default.createElement(JoinEntity_1.default, { layout: props.layout, min: props.min, max: props.max, embeddingEntityFilter: embeddingEntityFilter, joinEntity: embeddingEntityFilter.joinEntity, tableFilterSettings: tableFilterSettings, entity: entity, treeViewLevel: props.treeViewLevel, dataViewType: commonTypes_1.DataViewType.simpleView, joinEntityData: joinEntityData, entityData: data, mainEntityId: embeddingEntityFilter.value, changeEntityFilterSettings: function (settings) { return setEntityFilterSettings(settings); }, changeJoinFilterSettings: function (settings) { return setJoinFilterSettings(settings); }, reloadJoinEntityData: function () {
                                switchDataLoading();
                            } }))))
                    : (react_1.default.createElement(react_1.default.Fragment, null, entity && screenDesign === commonTypes_1.ScreenDesign.mobile
                        ? (react_1.default.createElement(DataResponsiveTable_1.default, { editView: function (view) { return setEditView(view); }, entity: entity, embeddingEntityFilter: props.embeddingEntityFilter, treeViewLevel: props.treeViewLevel, dataViewType: dataViewType, data: data, reloadTableViewData: function () {
                                switchDataLoading();
                            } }))
                        : (react_1.default.createElement(DataTable_1.default, { editView: function (view) { return setEditView(view); }, entity: entity, embeddingEntityFilter: props.embeddingEntityFilter, treeViewLevel: props.treeViewLevel, dataViewType: dataViewType, data: data, reloadTableViewData: function () {
                                switchDataLoading();
                            } }))))))));
};
exports.default = DataTableView;
